<h3>{{ planName || 'Plan Actual' }}</h3>

<div class="flex flex-col gap-4">
  <span class="cd-text-lg font-normal truncate">A tu plan actual le quedan</span>
  <span class="cd-text-mono font-bold text-8xl italic">{{ daysRemaining ?? 0 }}</span>
  <span class="cd-text-mono font-semibold text-3xl truncate">días para caducar</span>
</div>

<button (click)="goToPlan()" class="btn btn-primary flex flex-row gap-2 items-center"
        style="border-radius: 0.5rem;width:7.625rem;padding: 0.5rem">
  <img alt="Calendar" class="filter-neutral-100 h-4" src="/assets/icons/feather/calendar.svg">
  <span class="cd-text-md truncate">Abrir plan</span>
</button>
